import { useCreateQueryKeys as e } from "@maat/store-hooks";
//#region src/workspaces/useWorkspaceQueryKeys.ts
var t = e("workspaces", {
	list: () => ["list"],
	members: () => ["members"],
	invitations: () => ["invitations"],
	roles: () => ["roles"],
	role: (e) => ["role", e],
	roleMembers: (e) => ["role-members", e],
	allPermissions: () => ["all-permissions"],
	memberPermissions: (e) => ["member-permissions", e],
	validateInvite: (e) => ["validate-invite", e],
	responseStats: (e) => e ? ["response-stats", e] : ["response-stats"]
});
//#endregion
export { t as workspaceQueryKeys };
